import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import { ScalrBreadcrumb } from '@/components/customComponents'
import FilterBar from '@/components/FilterBar'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'

import { FEATURE_MATRIX } from '@/config/features'
import { selectTenant, useAppSelector } from '@/store'

import PnlLensPage from '@/screens/clarityLens/PnlLensPage'
import SalesLensPage from '@/screens/clarityLens/SalesLensPage'
import SpendLensPage from '@/screens/clarityLens/SpendLensPage'
import { NotAllowedClarityPage } from '@/screens/error'

function LensPageContent() {
  const { t } = useTranslation()
  const { id } = useParams()

  const tenant = useAppSelector(selectTenant)
  const features = FEATURE_MATRIX[tenant]

  return (
    <>
      <FilterBar pageId={id} />

      {id === 'sales-lens' &&
        (features.clarityLensSales ? (
          <>
            <SalesLensPage />
          </>
        ) : (
          <NotAllowedClarityPage
            pageTitle={t('clarityLens.navigation.salesLens')}
          />
        ))}

      {id === 'spend-lens' &&
        (features.clarityLensSpend ? (
          <SpendLensPage />
        ) : (
          <NotAllowedClarityPage
            pageTitle={t('clarityLens.navigation.spendLens')}
          />
        ))}

      {id === 'labor-lens' &&
        (features.clarityLensLabor ? (
          <div>{t('scalrBase.navigation.masterLabor')}</div>
        ) : (
          <NotAllowedClarityPage
            pageTitle={t('clarityLens.navigation.laborLens')}
          />
        ))}

      {id === 'pnl-lens' &&
        (features.clarityLensProfitAndLoss ? (
          <PnlLensPage />
        ) : (
          <NotAllowedClarityPage
            pageTitle={t('clarityLens.navigation.profitAndLossLens')}
          />
        ))}
    </>
  )
}

export default function LensPages() {
  const { t } = useTranslation()
  const { id } = useParams()

  return (
    <>
      <Card className="w-full">
        <CardHeader className="flex flex-row justify-between">
          <CardTitle pageTitle>
            {id === 'pnl-lens' && t('clarityLens.navigation.profitAndLossLens')}
            {id === 'sales-lens' && t('clarityLens.navigation.salesLens')}
            {id === 'spend-lens' && t('clarityLens.navigation.spendLens')}
            {id === 'labor-lens' && t('clarityLens.navigation.laborLens')}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <ScalrBreadcrumb
            breadcrumbItems={[
              { label: t('clarityLens.navigation.clarityLens') },
            ]}
            title={
              id === 'pnl-lens'
                ? t('clarityLens.navigation.profitAndLossLens')
                : id === 'sales-lens'
                  ? t('clarityLens.navigation.salesLens')
                  : id === 'spend-lens'
                    ? t('clarityLens.navigation.spendLens')
                    : id === 'labor-lens'
                      ? t('clarityLens.navigation.laborLens')
                      : ''
            }
          />
          <LensPageContent />
        </CardContent>
      </Card>
    </>
  )
}
